export default __webpack_public_path__ + "static/media/DSC03456.3a5cfd1b.JPG";